// import
// Trim 2026-06-18 — sự cố pentest yêu cầu minimize attack surface, BE
// waebox-otp đã DISABLE các router member/link/device/memberDevice/post/
// settingApp/packageApp/postAppSetting/ads. FE menu chỉ còn User + SMTP
// Server + Profile.
import React from "react";
import { FaUser, FaServer, FaShieldAlt } from "react-icons/fa";

import Profile from "views/Dashboard/Profile.js";
import SignIn from "views/Pages/SignIn.js";
import User from "views/Dashboard/User/User";
import WhitelistIp from "views/Dashboard/WhitelistIp/WhitelistIp";
import "@trendmicro/react-paginations/dist/react-paginations.css";
import { PersonIcon } from "components/Icons/Icons";
import { Roles } from "utils/constant";
import SMTPServer from "views/Dashboard/SMTPServer/SMTPServer";
import SMTPServerDetail from "views/Dashboard/SMTPServerDetail/SMTPServerDetail";

var dashRoutes = [
  {
    path: "/user",
    name: "User",
    icon: <FaUser color="inherit" />,
    component: User,
    layout: "/admin",
    role: [Roles.ADMIN],
  },
  {
    path: "/whitelist-ip",
    name: "Whitelist IP",
    icon: <FaShieldAlt color="inherit" />,
    component: WhitelistIp,
    layout: "/admin",
    role: [Roles.ADMIN],
  },
  {
    path: "/stmp",
    name: "SMTP Server",
    rtlName: "لوحة القيادة",
    icon: <FaServer color="inherit" />,
    component: SMTPServer,
    layout: "/admin",
    role: [Roles.ADMIN],
  },
  {
    path: "/backup-email/:brand",
    name: "SMTP Server Detail",
    redirect: true,
    icon: <FaServer color="inherit" />,
    component: SMTPServerDetail,
    layout: "/admin",
    role: [Roles.ADMIN],
  },
  {
    name: "ACCOUNT PAGES",
    category: "account",
    rtlName: "صفحات",
    state: "pageCollapse",
    views: [
      {
        path: "/profile",
        name: "Profile",
        icon: <PersonIcon color="inherit" />,
        secondaryNavbar: true,
        component: Profile,
        layout: "/admin",
        role: [Roles.ADMIN, Roles.USER, Roles.GUEST],
      },
      {
        path: "/signin",
        component: SignIn,
        layout: "/auth",
      },
    ],
  },
];
export default dashRoutes;
